import React from "react";
import Layout from "Layout";
import Form from "./form";
import useApi from "Hooks/useApi";
import useError from "Hooks/useError";
import { message } from "constants/message";
import useAuth from "Hooks/useAuth";
import googleAnalytics from "fuction/googleAnalytics";

export default function Edit(props) {
  const { params } = props.match;
  const userId = parseInt(params.id, 10);

  const { request } = useApi();
  const stateError = useError();
  const { state } = useAuth();
  const messages = message();
  const [user, setUser] = React.useState(null);

  const handleSubmit = ({ name, email, password, userType }) => {
    request({
      method: "PUT",
      url: `config/:account_id/users/${userId}`,
      data: {
        name: name,
        email: email,
        password: password,
        user_type: userType,
      },
    })
      .then((data) => {
        stateError.initialize();
        props.history.push("/config/user?success=edit");
      })
      .catch((error) => {
        stateError.dispatch({
          type: "set",
          payload: {
            isError: true,
            errorMsg: messages.validation.common,
          },
        });
      });
  };

  const fetchData = () => {
    if (!state.user.account_id) {
      return;
    }

    // アカウント情報取得
    request({
      method: "GET",
      url: `config/:account_id/users/${userId}`,
    }).then((data) => {
      setUser(data.data);
    });
    
  };

  React.useEffect(() => {
    // タイトル変更
    document.title = "Buzz Finder - ユーザ編集";
    
    fetchData();
  }, [state.user.account_id]);

  React.useEffect(() => {
    googleAnalytics(props.location.pathname, state.user.account_id);
  }, [props.location.pathname]);

  return (
    <Layout
      content={
        <Form
          submit={handleSubmit}
          user={user}
          isEdit={true}
        />
      }
    />
  );
}
